import { CHANGE_PASSWORD_TYPES } from './constants';

const initialState = {
  changePasswordFormData: null,
  personalInfoFormData: null,
};

export const changePasswordProcessReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_PASSWORD_TYPES.PROCEED: {
      return {
        ...state,
        changePasswordFormData: action.payload,
      };
    }

    case CHANGE_PASSWORD_TYPES.PERSONAL_INFO_CHANGE: {
      return {
        ...state,
        personalInfoFormData: action.payload,
      };
    }

    case CHANGE_PASSWORD_TYPES.RESET: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/auth/changePassword/reducer.js